// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hF","heroImageWrapper":"hG","gradientLeft":"hH","gradientBottom":"hI","brandLogo":"hJ"};